import { render } from "./Authenticator.vue?vue&type=template&id=a617aba8&scoped=true"
import script from "./Authenticator.vue?vue&type=script&lang=js"
export * from "./Authenticator.vue?vue&type=script&lang=js"

import "./Authenticator.vue?vue&type=style&index=0&id=a617aba8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a617aba8"]])

export default __exports__